import { render, staticRenderFns } from "./editCasaMatriz.vue?vue&type=template&id=3c345289&scoped=true&"
import script from "./editCasaMatriz.vue?vue&type=script&lang=js&"
export * from "./editCasaMatriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c345289",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c345289')) {
      api.createRecord('3c345289', component.options)
    } else {
      api.reload('3c345289', component.options)
    }
    module.hot.accept("./editCasaMatriz.vue?vue&type=template&id=3c345289&scoped=true&", function () {
      api.rerender('3c345289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/perfilEmpresa/editCasaMatriz.vue"
export default component.exports